<template>
  <div class="self-center">
    <div class="flex-row flex-wrap">
      <!-- View -->
      <b-button v-b-tooltip.hover.top="'Click here to view the company details'" class="btn-icon small-space"
        variant="outline-dark" @click="viewRecord">
        <feather-icon icon="EyeIcon" svg-classes="hover:text-primary stroke-current" />
      </b-button>

      <!-- Edit -->
      <b-button v-if="$checkRights(this.$route.meta.section, 'update')" v-b-tooltip.hover.top="'Edit this user'"
        class="btn-icon small-space" variant="outline-dark" @click="editRecord">
        <feather-icon class="text-warning" icon="EditIcon" svg-classes="hover:text-primary stroke-current" />
      </b-button>

      <!-- Deacivate -->
      <b-button v-if="$checkRights(this.$route.meta.section, 'delete') && (company_active == true)"
        v-b-tooltip.hover.top="'Deactivate this user'" class="btn-icon small-space" variant="outline-dark"
        @click="confirmDeleteRecord">
        <feather-icon class="text-danger" icon="Trash2Icon" svg-classes="hover:text-primary stroke-current" />
      </b-button>

      <!-- Reactivate -->
      <b-button v-if="$checkRights(this.$route.meta.section, 'delete') && (company_active == false)"
        v-b-tooltip.hover.top="'Reactivate this user'" class="btn-icon small-space" variant="outline-dark"
        @click="confirmReactivateRecord">
        <feather-icon class="text-success" icon="CheckCircleIcon" svg-classes="hover:text-primary stroke-current" />
      </b-button>
    </div>
  </div>
</template>

<script>


export default {
  name: 'CellRendererActions',
  props: {
    params: Object,
  },
  data() {
    return {
      company_active: true,
      isLoading: false,
    }
  },
  created() {
    this.$http.get(`/api/companies/${this.params.id}`, {})
      .then(response => {
        this.company_active = response.data.active;
      })
  },
  methods: {
    viewRecord() {
      this.$router.push({ name: 'companies-view', params: { id: this.params.id } })
    },

    editRecord() {
      if (this.$checkRights(this.$route.meta.section, 'update')) {
        this.$router.push({ name: 'companies-edit', params: { id: this.params.id } })
      } else {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Inadequate permission',
              icon: 'CheckCircleIcon',
              text: 'You dont have enough rights to update data in this section',
              variant: 'danger',
              position: 'center',
            },
          },
          { timeout: this.$longestTimeout },
        )
      }
    },

    invokeParentMethod(popup, edit_data) {
      this.params.context.componentParent.methodFromParent(popup, edit_data)
    },
    confirmReactivateRecord() {
      if (this.$checkRights(this.$route.meta.section, 'delete')) {
        this.$bvModal
          .msgBoxConfirm(
            `Are you sure you want to reactivate "${this.params.company_name}"`,
            {
              title: 'Confirm User Reactivation',
              size: 'sm',
              okVariant: 'danger',
              okTitle: 'Reactivate',
              cancelTitle: 'Cancel',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then(value => {
            if (value) {
              this.reactivateRecord()
            }
          })
      } else {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Inadequate permission',
              icon: 'CheckCircleIcon',
              text: "You don't have enough rights to deactivate data in this section",
              variant: 'danger',
              position: 'center',
            },
          },
          { timeout: this.$longestTimeout },
        )
      }
    },
    confirmDeleteRecord() {
      if (this.$checkRights(this.$route.meta.section, 'update')) {
        this.$bvModal
          .msgBoxConfirm(
            `Are you sure you want to delete "${this.params.company_name}"`,
            {
              title: 'Confirm User Deletion',
              size: 'sm',
              okVariant: 'danger',
              okTitle: 'Deactivate',
              cancelTitle: 'Cancel',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then(value => {
            if (value) {
              this.deleteRecord()
            }
          })
      } else {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Inadequate permission',
              icon: 'CheckCircleIcon',
              text: "You don't have enough rights to deactivate data in this section",
              variant: 'danger',
              position: 'center',
            },
          },
          { timeout: this.$longestTimeout },
        )
      }
    },
    deleteRecord() {
      // const { id } = this.$store.state.auth.ActiveUser || {}
      // if (id === this.params.user_id) {
      //   this.$toastDanger('Operation Failed', 'You cannot deactivate your own account.')
      // } else {
      //   this.showDeleteSuccess()

      //   this.$emit('refresh-record', true)
      //   // this.params.context.componentParent.get_company_users();
      // }

      this.showDeleteSuccess()
      window.location.reload()
    },
    reactivateRecord() {
      this.showReactivateSuccess()
      window.location.reload()
    },
    showDeleteSuccess() {
      const { token } = this.$store.state.auth.ActiveUser
      this.$http.defaults.headers.common.Authorization = `Token ${token}`
      this.isLoading = true

      this.$http
        .delete(`/api/companies/${this.params.id}`, {})
        .then(response => {
          const { output, success } = response.data

          if (success) {
            // this.params.context.componentParent.deleteSelected()

            this.$toastSuccess('Account Operations', 'Account deactivated successfully.')
            this.$emit('refresh-record', true)
          } else {
            this.$toastDanger('Account Operations', 'Could not deactivate this company, please try again later')
          }

          this.isLoading = false
        })
        .catch(error => {
          this.$handleErrorResponse(error, 'Account Operations', 'Could not deactivate this company, please try again later')

          this.isLoading = false
        })
    },

    showReactivateSuccess() {
      const { token } = this.$store.state.auth.ActiveUser
      this.$http.defaults.headers.common.Authorization = `Token ${token}`
      this.isLoading = true

      this.$http.put(`/api/companies/${this.params.id}/reactivate`, {})
        .then(response => {
          const { _, success } = response.data;
          if (success) {
            this.$toastSuccess('Account Operations', 'Account reactivated successfully.');
            this.$emit('refresh-record', true);
          } else {
            this.$toastDanger('Account Operations', 'Could not reactivate this company, please try again later');
          }

          this.isLoading = false
        })
        .catch(error => {
          this.$handleErrorResponse(error, 'Account Operations', 'Could not reactivate this company, please try again later.')
          this.isLoading = false
        })
    }
  },
}
</script>
<style scoped>
.small-space {
  margin-left: 2px;
  margin-right: 2px;
}
</style>
